import {
  Component,
  OnInit,
  Input,
  OnChanges, SimpleChanges
} from '@angular/core';
import { ViewEncapsulation } from '@angular/core';
import { NodeObject } from '../../../../shared/utils/nodeTypes';
import remove from 'lodash/remove';
import {StateService} from "../../../../core/services/store/state/state.service";
import {FlowType} from "../../../../shared/models/state/Flow";

@Component({
  selector: 'node-types',
  templateUrl: './node-types.component.html',
  styleUrls: ['./node-types.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class NodeTypesComponent implements OnInit, OnChanges {

  constructor(public stateService: StateService) { }

  @Input() title: string;
  @Input() nodes: NodeObject[];

  @Input() type: {};

  @Input() searchValue: string;

  isEmpty: boolean = false;

  filteredNodes: NodeObject[];
  incompatibleWithAPIFlows = ['menu'];

  ngOnInit() {
    if (this.nodes) {
      remove(this.nodes, { show: false });
      if (this.type) {
        this.filteredNodes = this.nodes.filter(nodeObject =>  this.isCompatibleWithAPIFlow(nodeObject) && nodeObject.sortType === this.type['key']);
      } else {
        this.filteredNodes = this.nodes.filter(nodeObject => this.isCompatibleWithAPIFlow(nodeObject));
      }
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.nodes && this.type) {
      this.filteredNodes = this.nodes.filter(nodeObject => nodeObject.sortType === this.type['key']);
      return;
    }
    if (changes.searchValue) {
      this.filteredNodes = this.nodes.filter(nodeObject => {
        return this.isCompatibleWithAPIFlow(nodeObject)
            && nodeObject.title.toUpperCase().includes(this.searchValue.toUpperCase());
      });
      this.isEmpty = !this.filteredNodes.length;
      return;
    }
  }

  private isCompatibleWithAPIFlow(nodeObject: NodeObject) {
    if (this.stateService.getFlowMetaData().flowType === FlowType.ApiFlow) {
      return !(this.incompatibleWithAPIFlows.includes(nodeObject.type));
    }
    return true;
  }

  dragstart(event: any, node: NodeObject) {
    const nodes = JSON.parse(localStorage.getItem('nodes'));
    if (nodes) {
      nodes[node.nodeType]++;
      localStorage.setItem('nodes', JSON.stringify(nodes));
    }
    event.dataTransfer.setData('nodeType', node.nodeType);
    event.dataTransfer.setData('stepType', node.type);
    if (node.extraFields) {
      const extraFields = node.extraFields as any;
      event.dataTransfer.setData('extraFieldsImg', extraFields.imageUrl);
      event.dataTransfer.setData('extraFieldsProvider', extraFields.providerId);
    }

    this.configureDragImage(event, node);
  }

  configureDragImage(event: any, node: NodeObject) {
    const container = document.getElementById('drag-img-container');
    if (container) {
      container.remove();
    }

    const newContainer = document.createElement('div');
    const image = document.createElement('img');

    newContainer.id = 'drag-img-container';
    newContainer.style.position = 'relative';
    newContainer.style.width = '36px';
    newContainer.style.height = '26px';

    image.src = node.image.primary;
    image.style.position = 'absolute';
    image.style.width = '100%';
    image.style.height = 'auto';

    newContainer.appendChild(image);
    document.getElementsByTagName('body')[0].appendChild(newContainer);
    event.dataTransfer.setDragImage(newContainer, 45, 45);
  }
}
